import React from 'react';
import { Icon, Radio } from 'antd';
import { Cell } from 'fixed-data-table-2';
import Checkbox from '../basic/checkbox'
import Row from '../basic/row'
import * as format from '../../helpers/formatDate'
import { getPredicateValue, getRoundValue } from '../../helpers/util'
import * as FormatterMap from '../../../../common/components/formatter';
import SvgIcon from 'SvgIcon';

export default class CellModel extends React.Component {
  constructor(props) {
    super(props);
    const rowIndex = props.RowProperty.rowIndex;
    const columnKey = props.RowProperty.columnKey;
    const rowContentHeight = props.rowContentHeight && props.rowContentHeight[rowIndex] && props.rowContentHeight[rowIndex][columnKey];
    this.state = {
      rowContentHeight
    };
    this.isIos = cb.utils.isIos();
  }
  componentDidMount () {
    const { openContentHeight } = this.props;
    // 只有开启状态，才开启重绘
    if (openContentHeight) {
      let height = this.refs.textCol ? (this.refs.textCol.clientHeight || 0) + 8 : 0
      if (height < this.props.fixedRowHeight) height = this.props.fixedRowHeight; // 最小行高为默认行高
      const rowIndex = this.props.RowProperty.rowIndex;
      const columnKey = this.props.RowProperty.columnKey;
      // 多文本域初次重新渲染
      const Column = this.props.Column
      const cControlType = Column.cControlType || '';
      if (cControlType && cControlType.toLocaleLowerCase() === 'composite' && this.props.model) {
        this.props.model.setCache('autoHeightForceUpdate', true);
      }
      this.props.setColHeight && this.props.setColHeight(rowIndex, height, columnKey);
    }
  }
  componentWillReceiveProps (nextProps) {
    const rowIndex = nextProps.RowProperty.rowIndex;
    const columnKey = nextProps.RowProperty.columnKey;
    const rowContentHeight = nextProps.rowContentHeight && nextProps.rowContentHeight[rowIndex] && nextProps.rowContentHeight[rowIndex][columnKey];
    this.calcCellHeight(nextProps, rowContentHeight);
    this.setState({ rowContentHeight })
  }
   // 获取单元格高度
   calcCellHeight=(nextProps, rowContentHeight) => {
    const { openContentHeight, Column, CellStatus, RowProperty } = nextProps
    if (openContentHeight) {
      const { cControlType = '' } = Column;
      const extraConfig = Column.cStyleJSON || {};
      // 只处理多文本编辑
      const _type = cControlType && cControlType.toLocaleLowerCase()
      if (_type == 'composite' || _type === 'pictureupload' || _type == 'textarea' || ((_type == 'input' && extraConfig.type == 'textarea') || extraConfig.tag == true)) {
        const { rowIndex, columnKey } = RowProperty;
        let forceUpdate;
        if (this.props.model) {
          forceUpdate = this.props.model.getCache('autoHeightForceUpdate');
          this.props.model.clearCache('autoHeightForceUpdate');
        }
        // 编辑态
        if (CellStatus) {
          const editHeight = this.refs.editCol ? (this.refs.editCol.clientHeight || 0) + 18 : rowContentHeight;
          this.props.setColHeight && this.props.setColHeight(rowIndex, editHeight, columnKey, forceUpdate, true);
        } else {
          let height = this.refs.textCol ? (this.refs.textCol.clientHeight || 0) + 8 : rowContentHeight;
          if (height < this.props.fixedRowHeight) height = this.props.fixedRowHeight; // 最小行高为默认行高
          this.props.setColHeight && this.props.setColHeight(rowIndex, height, columnKey, forceUpdate);
        }
      }
    }
  }
  //组合控件切换浏览态
  setCellBlur(index, columnKey) {
    let data = { rowIndex: index, cellName: columnKey };
    this.props.setCellBlur(data);
  }
  setCell() {
    let self = this;
    let property = this.props.RowProperty;//行属性
    let col = this.props.Column;//栏目信息
    let controlType = col.cControlType;
    let index = property.rowIndex;//行号
    let cellState = { disabled: false, visible: false, readOnly: false, style: {} };//单元格状态
    let isColErro = this.props.isColErro;//错误
    if (this.props.cellState[index] && this.props.cellState[index][property.columnKey]) {
      cellState.disabled = this.props.cellState[index][property.columnKey].disabled;
      cellState.visible = this.props.cellState[index][property.columnKey].visible;
      cellState.readOnly = this.props.cellState[index][property.columnKey].readOnly;
      cellState.style = cb.utils.extend(true, {}, this.props.cellState[index][property.columnKey].style);
    }
    cellState.style.height = property.height;
    if (controlType && controlType.trim().toLocaleLowerCase() != 'avatar')
      cellState.style.padding = '12px 10px';
    cellState.style.lineHeight = '14px';
    if (isColErro) {
      cellState.style.border = '1px solid #ff7733';
    }

    let data = this.props.dataList;
    if (data[index]) {
      //操作列
      if (col.cControlType == 'Action') {
        let actionList = this.props.action.controls;
        let actionState = this.props.actionState;
        let actionControl = [];
        if (actionList && actionList.length > 0) {
          actionList.map(function (action) {
            const icon = action.iStyle === 1 ? null : action.icon;
            const text = action.iStyle === 2 ? null : action.cShowCaption;
            const iconCom = icon ? (
              <SvgIcon className={'icon-' + icon} type={icon} />
            ) : null;
            if (actionState[index] && actionState[index][action.cItemName] && actionState[index][action.cItemName].visible) {
              if (action.cControlType != 'popbutton') {
                let temp_action = (
                  <span key={action.cItemName}>
                    <a className="table-list-btn" data-value={action.cItemName}  title={text} onClick={(e) => this.props.ActionClick(e, action, index)}>
                      {iconCom}{text}
                    </a>
                  </span>
                );
                actionControl.push(temp_action);
              }
            }
          }, this);
          return (<div className="acticonCell"><Row>{actionControl}</Row></div>);
        } else {
          return <div className="acticonCell"><Row></Row></div>;
        }
      } else {
        let Cell = this.RemodelingCell(property, col, cellState);
        return Cell
      }
    }
  }
  //组织Cell
  RemodelingCell(rowIndex, col, cellState) {
    let { cControlType, formatter, bCanModify, bJointQuery } = col;
    const { cStyle } = this.props.Column;
    let index = rowIndex.rowIndex;
    let columnKey = rowIndex.columnKey;
    let data = this.props.dataList;
    let readOnly = this.props.readOnly;
    let className = "textCol";
    cControlType = cControlType ? cControlType : 'Input';
    if (cControlType === 'refer' || cControlType.trim().toLocaleLowerCase() === 'refer') {
      cellState.style.textAlign = 'left';
    }
    cellState.style.width = rowIndex.width;
    const _isTextArea = cControlType.toLocaleLowerCase() === 'textarea';
    let cName = _isTextArea ? 'textarea-maxheight' : 'textCol';
    if (cellState.className && cellState.className != '') cName = cName + '  ' + cellState.className;
    if (col.className && col.className != '') cName = cName + '  ' + col.className;
    if (this.props.lastCol && this.props.actionTipled && col.iAlign === 3) {
      cName += ' padding-right-60';
    }

    if (formatter) {
      const cellObj = formatter(rowIndex, data[index]);
      if (cellObj.formatterKey) {
        const ComName = FormatterMap[cellObj.formatterKey];
        if (!ComName)
          return null;
        return <Cell width={rowIndex.width} height={rowIndex.height}>
          <div style={cellState.style} className='textCol'>
            <ComName model={this.props.model} {...cellObj.props} />
          </div>
        </Cell>
      }
      let cellHtml = '', cellText = '';
      const cellProps = {};
      if (cellObj && cellObj.html) {
        cellHtml += cellObj.html;
        cellText += cellObj.text || cellObj.html;
        Object.assign(cellProps, cellObj.props);
      }
      const cellCom = (
        <span title={cellText} dangerouslySetInnerHTML={{ __html: cellHtml }} {...cellProps}></span>
      );
      return <Cell width={rowIndex.width} height={rowIndex.height}>
        <div style={cellState.style} className={className}>
          {cellObj && cellObj.override ? null : <span title={data[index][columnKey]}>{data[index][columnKey]}</span>}
          {cellCom}
        </div>
      </Cell>
    }
    //行号
    if (columnKey === 'GridRowNo') {
      return (
        <Cell width={rowIndex.width} height={rowIndex.height}>
          <div className='rowNo' style={{ width: rowIndex.width, height: rowIndex.height, textAlign: 'left' }}>
            <span className='change-rowNo'> {index + 1}</span>
          </div>
        </Cell>
      );
    }
    //选择框
    if (columnKey === 'CheckBox') {
      if (this.props.GridProps.isRadio || this.props.hasAction) {
        return (
          <Cell className="retail-table-checkbox" width={rowIndex.width} height={rowIndex.height}>
            <Radio checked={this.props.dataList[index]._selected}
              onChange={(e) => this.SelectChange(e, index)}></Radio>
          </Cell>
        )
      } else {
        return (
          <Cell className="retail-table-checkbox" width={rowIndex.width} height={rowIndex.height}>
            <Checkbox value={this.props.dataList[index]._selected}
              onChange={(e, i) => this.SelectChange(e, index)}></Checkbox>
          </Cell>
        );
      }
    }
    let style = {};
    if (this.props.openContentHeight) {
      style = {
        lineHeight: '18px',
        whiteSpace: 'normal',
        wordBbreak: 'break-all',
        width: '100%'
      }
    }
    const text = this.RemodelingFormatControl(cControlType, data[index][columnKey], bJointQuery, index, columnKey)
    const title = cControlType === 'Input' && this.props.Column.encrypt ? getEncryptValue(text, this.props.Column) : data[index][columnKey]
    const cellContent = (
      <Cell width={rowIndex.width} height={rowIndex.height} className='retail-table-cell'>
        <div title={title} textheight={this.props.openContentHeight && rowIndex.height < 150 ? 'textheight' : ''} className={cName} style={cellState.style}>
          <div title={title} ref='textCol' style={style}>
            {text}
          </div>
        </div>
      </Cell>
    );
    return cellContent;
  }
  ///////////////////////////////////////////////End-为comboGrid形式的控件单独支持的方法////////////////////////////////////////////////////////////////////////
  //构建formatControls结构
  RemodelingFormatControl(controlType, text, bJointQuery, index, columnKey) {
    switch (controlType && controlType.trim().toLocaleLowerCase()) {
      case 'refer':
      case 'treerefer':
      case 'listrefer': {
        let formatText = text != null && typeof text === 'object' ? text.name : text;
        return bJointQuery ? <a onClick={e => this.handleJointQuery(e, index, columnKey)}>{formatText}</a> : formatText;
      }
      case 'select': {
        if (cb.utils.isEmpty(text))
          return text;
        let formatText = null;
        if (typeof text !== 'object')
          formatText = text;
        else if (text.nameType === 'icontext')
          formatText = <span><Icon type={text.icon} />{text.text}</span>
        else if (text.nameType === 'icon')
          formatText = <Icon type={text.icon} />
        else
          formatText = text.text;
        return bJointQuery ? <a onClick={e => this.handleJointQuery(e, index, columnKey)}>{formatText}</a> : formatText;
        return typeof text === 'object' ? text.text : text;
      }
      case 'inputnumber':
      case 'money':
      case 'price':
        if (cb.utils.isEmpty(text)) return '';
        if (isNaN(text)) return text;

        /*谓词变量支持系统参数*/
        let cFormatData = this.props.Column.cFormatData;
        try {
          if (!cFormatData || cFormatData == '') {
            cFormatData = {};
          } else {
            cFormatData = JSON.parse(cFormatData);
          }
        } catch (e) {
          cb.utils.alert('数量/金额/单价，预制错误！', 'error');
        }
        text = parseFloat(text);
        let iNumPoint = this.props.Column.iNumPoint;
        let decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
        if (controlType === 'money') {
          if (decimal)
            iNumPoint = decimal;
          else
            iNumPoint = cb.rest.AppContext.option.amountofdecimal;
        }
        else if (controlType === 'price') {
          if (decimal)
            iNumPoint = decimal;
          else
            iNumPoint = cb.rest.AppContext.option.monovalentdecimal;
        } else {
          if (decimal)
            iNumPoint = decimal;
          else
            if (cb.utils.isEmpty(iNumPoint)) iNumPoint = null;
        }

        if (!isNaN(iNumPoint) && iNumPoint != null) {
          text = parseFloat(text);
          text = getRoundValue(text, iNumPoint);
        }

        if (cFormatData.after) text = text + cFormatData.after;

        return text;
      case 'datepicker':
        if (text) {
          let fmt = 'YYYY-MM-dd';
          if (this.props.Column.cFormatData && this.props.Column.cFormatData != '') {
            fmt = this.props.Column.cFormatData;
          }
          if(this.isIos) {
            text = text.replace(/\-/g, "/");
            fmt = fmt.replace(/\-/g, "/");
          }
          text = format.dateFormat(new Date(text), fmt)
        }
        return text;
      case 'avatar':
        if (!text || text == '') {
          return <div className="no-avatar-man"></div>
        } else {
          let style = {};
          style.height = this.props.rowHeight;
          style.width = this.props.rowHeight;
          return <img src={text + '?imageView2/1/w/80/h/80'} style={style} />
        }
        case 'composite': {
          const crossEntity = this.props.Column.crossEntity;
          // let CompositeLayout = this.props.CompositeLayout[index][columnKey];
          let CompositeLayout = JSON.parse(this.props.Column.cStyle).compositeLayout;
          if (crossEntity) {
            CompositeLayout = this.props.Column.compositeControls.controls
          }
          if (cb.utils.isEmpty(CompositeLayout)) return '';
          const CompositeJson = CompositeLayout;
          const compositeData = this.analysisComposite(CompositeJson, index, columnKey, crossEntity);
          return compositeData;
        }
    }
    if (text === '')
      return ''
    return bJointQuery ? <a onClick={e => this.handleJointQuery(e, index, columnKey)}>{text}</a> : text;
  }
  //监听选择
  SelectChange(checked, index) {
    if (typeof checked == 'object')
      checked = checked.target.checked;
    let all = false;
    if (this.props.GridProps.isRadio || this.props.hasAction) all = true;
    if (checked) {
      if (all) {
        this.props.model.select([index], all);
      } else {
        this.props.model.select(index, all);
      }
    } else {
      this.props.model.unselect(index);
    }
  }
  handleJointQuery(e, index, columnKey) {
    let dataArry = this.props.dataList;
    let rowData = dataArry[index];
    // this.props.model.fireEvent('dblClick', rowData);
    this.props.model.execute('cellJointQuery', {
      rowIndex: index,
      cellName: columnKey
    });
  }
   // 解析浏览态的复合组件行
   analysisComposite (Json, index, columnKey, crossEntity) {
    const self = this;
    const rowData = self.props.dataList[index];
    const columns = self.props.model.getColumn(columnKey) || {}
    if (Json.length < 0) return;
    const Control = [];
    if (crossEntity) {
      const datas = rowData[crossEntity]
      if (datas) {
        const Row = self.analysisCrossEntityRow(Json, datas, crossEntity, index, columnKey)
        if (!Row) return;
        Control.push(Row);
      }
    } else {
      Json.map(function (r) {
        const Row = self.analysisRow(r, rowData);
        if (!Row) return;
        Control.push(Row);
      });
    }
    if (!columns.compositeControls) {
      return <div className='composite-container'>{Control}</div>
    }
    return <div
      onClick={() => {
              this.props.model.setCellState(index, columnKey, 'compositeVisible', true)
      }}
      style={{ minHeight: 28 }}
      className='composite-container autoHeightCol textCol'>{Control}</div>;
  }

  analysisCrossEntityRow (Json, datas, crossEntity, index, columnKey) {
    const viewModel = this.props.model.getParent();
    const gridModel = viewModel.get(crossEntity)
    const self = this
    const RowControl = [];
    datas.forEach((item, i) => {
      if (RowControl.length > 4) return;
      const dom = [];
      Json.forEach(ele => {
        const itemName = ele.cItemName
        const bJointQuery = ele.bJointQuery
        const span = item[itemName]
        if (span) {
          // 取到数据进行拼接
          if (span.bHideInCell !== true) {
            const value = self.analysisEnumctrl(gridModel, itemName, span)
            if (bJointQuery) {
              const a = <a
                style={{display: 'inline-block', height: '100%'}}
                title={typeof value === 'string' ? value : ''}
                onClick={e => {
                  e.stopPropagation();
                  const obj = {rowIndex: i, cellName: itemName, row: item, parentRowIndex: index, parentColumnKey: columnKey, viewModel: viewModel, gridModel: gridModel};
                  gridModel.execute('crossEntityJointCellQuery', obj)
                }}>{value}</a>
              dom.push(<span style={{...ele.style, display: 'inline-block'} || {}}> {a} </span>)
            } else {
              dom.push(<span style={{...ele.style, display: 'inline-block'} || {}}>{` ${value} `}</span>)
            }
          }
        }
      })
      if (RowControl.length < 4) {
        RowControl.push(<div>{dom}</div>)
      } else {
        RowControl.push(<div><a href='javascript:void(0);'>{cb.lang.templateByUuid('UID:P_FW_174E6C8C05280A52', '查看更多')}</a></div>)
      }
    })
    return (<Row style={{ height: 'initial' }}>{RowControl}</Row>);
  }

  // 解析复合组件row
  analysisRow (rowJson, rowData) {
    const self = this;
    if (rowJson.row.length < 0) return;
    const RowControl = [];
    let Col;
    const rowStyle = Object.assign({height: 'initial'}, rowJson.rowStyle); // 支持row上配置rowStyle
    rowJson.row.map(function (c) {
      Col = self.analysisCol(c, rowData);
      if (!Col) return false;
      RowControl.push(Col);
    });
    if (RowControl.length <= 0) return false;
    return (<Row style={rowStyle}>{RowControl}</Row>);
  }

  // 解析复合组件col
  analysisCol (colJson, rowData) {
    const self = this;
    if (colJson.col.length < 0) return;
    const ColControl = [];
    let colData;
    let flag = false;
    const columns = self.props.model.getColumns();
    colJson.col.map(function (item) {
      const style = item.style || {};
      const cCaption = item.cItemCaption; // 在CompositeLayout的col中配置cItemCaption，扩展从rowData数据中获取caption
      const caption = cCaption ? _.get(rowData, cCaption) || '' : columns[item.cItemName] && columns[item.cItemName].cShowCaption;
      const iNumPoint = columns[item.cItemName] && columns[item.cItemName].iNumPoint;
      let showResult = '';
      if (rowData[item.cItemName] == undefined || rowData[item.cItemName] === '' || rowData[item.cItemName] == 'undefined') return false;
      showResult = self.analysisEnumctrl(self.props.model, item.cItemName, rowData[item.cItemName])
      let showCaption = item.bShowCaption ? caption + (caption ? ':' : '') + showResult : showResult;
      if (typeof showCaption === 'number' && !isNaN(showCaption) && iNumPoint !== undefined) {
        showCaption = cb.utils.getRoundValue(showCaption, iNumPoint) * 1
      }
      if (cb.utils.isPlainObject(showCaption)) {
        const model = self.props.model && self.props.model.getEditRowModel() && self.props.model.getEditRowModel().get(item.cItemName)
        const textField = model && model.get('textField') || 'text'
        showCaption = showCaption[textField] || showCaption.value
      }
      const valueField = item.cItemName + '|' + (_.get(rowData, item.cItemValueName) || showCaption); // 支持根据不同结果添加标识
      colData = (
        <span key={item.cItemName} data-value={valueField}>
          <span style={style}>{flag && (item.joinIcon || '')}<span>{showCaption}</span></span>
        </span>
      );
      flag = true
      ColControl.push(colData);
    });
    if (ColControl.length <= 0) return false;
    return ColControl;
  }

  // 映射枚举类型组件 数据cControlType必须配置为Select
  analysisEnumctrl (gridModel, itemName, cellData) {
    // girdModel判空，设计器环境可能会出错
    const model = gridModel.getEditRowModel().get(itemName)
    let result = cellData;
    if (model instanceof cb.models.BaseModel) {
      // 获取枚举映射关系
      const keyMap = model._get_data('keyMap')
      // 根据keyMap获取映射对应值
      if (keyMap) {
        // 有的枚举字段是塞的枚举值，设计器中塞的是一个枚举对象，做兼容
        result = keyMap[cellData] && keyMap[cellData][model.get('textField')] || (cb.utils.isPlainObject(cellData) ? cellData[model.get('textField')] : cellData) // 拿不到就给原值
      } else {
        // 处理其他特殊场景
        const cControlType = model.get('cControlType') && model.get('cControlType').toLocaleLowerCase();
        const cFormatData = model.get('cFormatData');
        const _fmt = cb.format && cb.format.defaultDateFormat;
        switch (cControlType) {
          case 'inputmultilang':
            if (cb.utils.isPlainObject(result)) {
              result = result[cb.lang && cb.lang.lang] || result.zh_CN
            }
            break;
          case 'datepicker':
            if (result != null) {
              result = cFormatData ? moment(result).format(cFormatData) : moment(result).format(_fmt)
            }
            break;
        }
      }
    }
    return result
  }
  render() {
    var Cell = this.setCell();
    return Cell;
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/grid-touch/CellModel.jsx